import {
  validateEmail,
  validateMobileNumber,
  validatePAN,
  validateStartupSocialURL,
  validateURL,
} from "../effects/utils/validations";
import { ErrorModel } from "../models/common/ErrorModel";
import { TeamDetails } from "../models/incubator/IncubatorTeamModel";
import { FundExpenseDetails } from "../models/startup/FundingDetailsModel";
export interface IRequireField {
  [key: string]: string[];
}
export class ValidationHelper {
  constructor(
    public state: any,
    public requiredFields: IRequireField,
    public nullFields: Array<string>
  ) {
    this.state = state;
    this.requiredFields = requiredFields;
    this.nullFields = nullFields;
  }
  public triggerValidation = () => {
    let errors: any = {};
    Object.keys(this.requiredFields).map((key: string) =>
      this.requiredFields[key].map((field: string) => {
        const value = this.state[key][field];
        const errorModel = new ErrorModel(field, "", value);
        let message: string = "";
        try {
          if (!this.nullFields.includes(field) && errorModel.isMandatory()) {
            message = `This is mandatory field`;
          } else {
            message = "";
          }
        } catch (error) {
          console.warn(`[${key}][${field}] - ${error}`);
        }
        message = this.entityDetailsValidations(field, key, message);
        message = this.startupDetailsValidations(field, key, message);
        message = this.authorizedRepresentativeValidations(field, key, message);
        message = this.startupTeamValidation(field, key, message);
        message = this.startupFundingExpenseValidation(field, key, message);
        message = this.uploadDocumentValidation(field, key, message);
        errors = {
          ...errors,
          [key]: {
            ...errors[key],
            [field]: message,
          },
        };
      })
    );
    return errors;
  };
  private entityDetailsValidations(
    field: string,
    key: string,
    message: string
  ) {
    if (field === "pan_number") {
      if (this.state[key]["pan_number"].length > 0) {
        message = validatePAN(this.state[key][field]);
      }
      else {
        message = ""
      }
    }
    return message;
  };
  private startupDetailsValidations(
    field: string,
    key: string,
    message: string
  ) {
    if ((field === "competitors_startup_enable" && this.state[key]["competitors_startup_enable"] == false) &&
      (this.state[key]["competitors_msme_enable"] == false) &&
      (this.state[key]["competitors_corporate_enable"] == false) &&
      (this.state[key]["competitors_other_enable"] == false)) {
      message = "This is mandatory field";
    }
    if ((field === "competitors_startup_desc" && this.state[key]["competitors_startup_desc"] === "" && this.state[key]["competitors_startup_enable"] == true) ||
      (field === "competitors_msme_desc" && this.state[key]["competitors_msme_desc"] === "" && this.state[key]["competitors_msme_enable"] == true) ||
      (field === "competitors_corporate_desc" && this.state[key]["competitors_corporate_desc"] === "" && this.state[key]["competitors_corporate_enable"] == true) ||
      (field === "competitors_other_desc" && this.state[key]["competitors_other_desc"] === "" && this.state[key]["competitors_other_enable"] == true)) {
      message = "This is mandatory field";
    }
    else if ((field === "competitors_startup_desc" && this.state[key]["competitors_startup_desc"] === "" && this.state[key]["competitors_startup_enable"] == false) ||
      (field === "competitors_msme_desc" && this.state[key]["competitors_msme_desc"] === "" && this.state[key]["competitors_msme_enable"] == false) ||
      (field === "competitors_corporate_desc" && this.state[key]["competitors_corporate_desc"] === "" && this.state[key]["competitors_corporate_enable"] == false) ||
      (field === "competitors_other_desc" && this.state[key]["competitors_other_desc"] === "" && this.state[key]["competitors_other_enable"] == false)) {
      message = ""
    }
    if (field === "website_url") {
      if (this.state[key]["website_url"].length > 0) {
        message = validateURL(this.state[key]["website_url"]);
      }
      else {
        message = ""
      }
    }
    if (field === "facebook_link") {
      if (this.state[key]["facebook_link"].length > 0) {
        message = validateStartupSocialURL(this.state[key]["facebook_link"]);
      }
      else {
        message = ""
      }
    }
    if (field === "linkedin_link") {
      if (this.state[key]["linkedin_link"].length > 0) {
        message = validateStartupSocialURL(this.state[key]["linkedin_link"]);
      }
      else {
        message = ""
      }
    }
    if (field === "twitter_link") {
      if (this.state[key]["twitter_link"].length > 0) {
        message = validateStartupSocialURL(this.state[key]["twitter_link"]);
      }
      else {
        message = ""
      }
    }
    if (field === "youtube_link") {
      if (this.state[key]["youtube_link"].length > 0) {
        message = validateStartupSocialURL(this.state[key]["youtube_link"]);
      }
      else {
        message = ""
      }
    }
    if (field === "other_link") {
      if (this.state[key]["other_link"].length > 0) {
        message = validateStartupSocialURL(this.state[key]["other_link"]);
      }
      else {
        message = ""
      }
    }
    return message
  }
  private authorizedRepresentativeValidations(
    field: string,
    key: string,
    message: string
  ) {
    if (field === "representative_mobile_no") {
      message = validateMobileNumber(this.state[key][field]);
    }
    if (field === "representative_email") {
      message = validateEmail(this.state[key][field]);
    }
    return message;
  }
  private startupTeamValidation = (
    field: string,
    key: string,
    message: string
  ) => {
    if (field === "team_data") {
      const teamDetails = this.state[key]["team_data"] as Array<TeamDetails>;
      const isEmpty = teamDetails.some(
        (teamDetail: TeamDetails) => teamDetail.team_name.length === 0
      );
      if (isEmpty) {
        message = "This is mandatory field";
      }
    }
    if (field === "ceo_linkedin_link") {
      if (this.state[key]["ceo_linkedin_link"].length > 0) {
        message = validateStartupSocialURL(this.state[key]["ceo_linkedin_link"]);
      }
      else {
        message = ""
      }
    }
    return message;
  };
  // private startupFundingExpenseValidation = (
  //   field: string,
  //   key: string,
  //   message: string
  // ) => {
  //   if (field === "fund_expense_data") {
  //     const fundingDetails = this.state[key]["fund_expense_data"] as Array<FundExpenseDetails>;
  //     const isEmpty = fundingDetails.some(
  //       (fundExpensesDetail: FundExpenseDetails) =>
  //         (fundExpensesDetail.expense_amount === 0) ||
  //         (fundExpensesDetail.expense_bucket.length === 0)
  //     );
  //     if (isEmpty) {
  //       message = "This is mandatory field";
  //     }
  //   }
  //   return message;
  // };
  private startupFundingExpenseValidation = (
    field: string,
    key: string,
    message: string
  ) => {

    // 🔍 DEBUG LOGS TO SEE WHAT EXACTLY IS FAILING
    if (field === "fund_expense_data") {
      console.log("🔍 VALIDATING FUND EXPENSE DATA");
      console.log("➡️ RAW DATA:", this.state[key]["fund_expense_data"]);

      const fundingDetails = this.state[key]["fund_expense_data"] as Array<FundExpenseDetails>;

      fundingDetails.forEach((item, index) => {
        console.log(`   👉 Row ${index}:`, item);
        console.log(
          `       expense_amount = ${item.expense_amount}`,
          ` | expense_bucket = `,
          item.expense_bucket
        );
      });

      const isEmpty = fundingDetails.some(
        (f: FundExpenseDetails) => {
          if (f.expense_bucket == null) {
            console.warn("❌ ERROR: expense_bucket is NULL for row:", f);
          }
          return (
            f.expense_amount === 0 ||
            !f.expense_bucket ||
            f.expense_bucket.length === 0
          );
        }
      );

      if (isEmpty) {
        message = "This is mandatory field";
      }
    }
    return message;
  };
  private uploadDocumentValidation(
    field: string,
    key: string,
    message: string
  ) {
    if (field === "video_url_for_product") {
      if (this.state[key]["video_url_for_product"].length > 0) {
        message = validateStartupSocialURL(this.state[key]["video_url_for_product"]);
      }
      else {
        message = ""
      }
    }
    return message;
  };
}

